import { baseApi } from "./baseApi";
import { setUser, setProfile, logout } from "../../slices/userSlice";
import { ProfileFormData } from "../../../types";

export const userApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({

    /** 🔐 LOGIN */
    login: builder.mutation<
      {
        userTelegram: any;
        profile: any;
        token: string;
      },
      { initData: string }
    >({
      query: ({ initData }) => ({
        url: "/auth",
        method: "POST",
        body: { initData },
      }),

      async onQueryStarted(_, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled;

          // 🍪 сохраняем токен
          document.cookie = `token=${data.token}; path=/; max-age=86400`;

          // 👤 сохраняем пользователя + профиль
          dispatch(
            setUser({
              userTelegram: data.userTelegram
            })
          );
        } catch (error) {
          // ❌ если логин упал — auth всё равно проверен
          dispatch(logout());
        }
      },
    }),

    /** 👤 GET PROFILE */
    getProfile: builder.query<any, void>({
      query: () => "/profile",

      async onQueryStarted(_, { queryFulfilled, dispatch }) {
        try {
          const { data } = await queryFulfilled;

          dispatch(setProfile(data.profile));
        } catch (error) {
          const status = (error as any)?.error?.status;

          if (status === 401 || status === 403) {
            dispatch(logout());
          }
        }
      },

      providesTags: ["User"],
    }),

    /** ✏️ UPDATE PROFILE */
    updateProfile: builder.mutation<any, ProfileFormData>({
      query: (body) => ({
        url: "/profile",
        method: "POST",
        body,
      }),
      invalidatesTags: ["User"],
    }),

    /** ❤️ UPDATE INTERESTS */
    updateProfileInterests: builder.mutation<any, any>({
      query: (body) => ({
        url: "/profile/interests",
        method: "POST",
        body,
      }),
      invalidatesTags: ["User"],
    }),

    /** 🌿 UPDATE LIFESTYLES */
    updateProfileLifestyles: builder.mutation<any, any>({
      query: (body) => ({
        url: "/profile/lifestyles",
        method: "POST",
        body,
      }),
      invalidatesTags: ["User"],
    }),

    /** 📸 UPLOAD PHOTO */
    uploadProfilePhoto: builder.mutation<any, FormData>({
      query: (formData) => ({
        url: "/profile/photo",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["User"],
    }),

    /** 🗑 DELETE PHOTO */
    deleteProfilePhoto: builder.mutation<any, number>({
      query: (id) => ({
        url: `/profile/photo/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["User"],
    }),

    /** 🔄 ROTATE PHOTO */
    rotateProfilePhoto: builder.mutation<any, { id: number; direction?: "left" | "right" | "180" }>({
      query: ({ id, direction = "right" }) => ({
        url: `/profile/photo/${id}/rotate`,
        method: "POST",
        body: { direction },
      }),
      invalidatesTags: ["User"],
    }),

    /** ⭐ SET MAIN PHOTO */
    setMainPhoto: builder.mutation<any, any>({
      query: (body) => ({
        url: "/profile/photo/set-main",
        method: "POST",
        body,
      }),
      invalidatesTags: ["User"],
    }),
  }),
});

export const {
  useLoginMutation,
  useGetProfileQuery,
  useUpdateProfileMutation,
  useUpdateProfileInterestsMutation,
  useUpdateProfileLifestylesMutation,
  useUploadProfilePhotoMutation,
  useDeleteProfilePhotoMutation,
  useRotateProfilePhotoMutation,
  useSetMainPhotoMutation,
} = userApi;
